import { NgModule } from "@angular/core";
import { FeatureToggleDisabledDirective } from "./directives/feature-toggle-disabled.directive";
import { FeatureToggleEnabledDirective } from "./directives/feature-toggle-enabled.directive";

@NgModule({
  declarations: [FeatureToggleEnabledDirective, FeatureToggleDisabledDirective],
  exports: [FeatureToggleEnabledDirective, FeatureToggleDisabledDirective],
})
export class FeatureTogglesModule {}
